import { head, last, startsWith, split, flow } from 'lodash/fp';
import uaParser from 'ua-parser-js';

const filterMilanoteUA = startsWith('Milanote');
const filterElectronUA = startsWith('Electron');

const splitSpace = split(' ');
const splitSlash = split('/');

const getVersion = flow(splitSlash, last);

export const parseUserAgent = (userAgent) => {
    const parts = splitSpace(userAgent);

    const milanoteAppUA = head(parts.filter(filterMilanoteUA));
    const electronUA = head(parts.filter(filterElectronUA));

    if (!milanoteAppUA) return;

    const appVersion = getVersion(milanoteAppUA);
    const electronVersion = getVersion(electronUA);

    return {
        appVersion,
        electronVersion,
        isElectron: !!electronVersion,
    };
};

export const safelyGetUserAgentBrowserName = (userAgent) => {
    if (!userAgent) return 'Unknown';

    try {
        const ua = uaParser(userAgent);

        return ua.browser.name;
    } catch (error) {
        return 'Unknown';
    }
};
